<template>
    <div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <field-wrapper
                        label="Aviation rank is"
                        option-label="label"
                        :options="options.comparisonTypes"
                        track-by="value"
                        v-model="values.comparison_one"
                        :error="errors.comparison_one"
                        type="select"
                />
            </div>
            <div class="col-lg-6 col-md-6">
                <field-wrapper
                        v-model="values.threshold_one"
                        :error="errors.threshold_one"
                        label="Aviation rank threshold"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <field-wrapper
                        label="And (optional)"
                        option-label="label"
                        :options="options.comparisonTypes"
                        track-by="value"
                        v-model="values.comparison_two"
                        :error="errors.comparison_two"
                        type="select"
                />
            </div>
            <div class="col-lg-6 col-md-6">
                <field-wrapper
                        v-model="values.threshold_two"
                        :error="errors.threshold_two"
                        label="Aviation rank threshold (optional)"
                />
            </div>
        </div>
        <span>Estimated impact of the event.</span>
    </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import {FILTER_OPTIONS} from '@/app/wdc/form/fixtures'

  const comparisonTypes = FILTER_OPTIONS.gtComparisonTypes.concat(FILTER_OPTIONS.ltComparisonTypes)
  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'aviationRankRangeFilter',
    data () {
      return {
        options: {
          comparisonTypes
        }
      }
    },
    methods: {}
  }
</script>
<style>
</style>
